"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterChildren = _interopRequireDefault(require("../../utils/Children/filterChildren"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.onCellClick = _this.onCellClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * on cell click will return rowIndex and columnIndex
   * @param {number} row
   * @param {number} column
   * @public
   */


  _createClass(Table, [{
    key: "onCellClick",
    value: function onCellClick(row, column, event) {
      if (this.props.onCellClick) {
        this.props.onCellClick(row, column, event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          noBorder = _this$props.noBorder,
          className = _this$props.className,
          id = _this$props.id,
          style = _this$props.style,
          secondaryDataList = _this$props.secondaryDataList,
          responsiveCardStyle = _this$props.responsiveCardStyle;

      var tableClass = function tableClass() {
        return (0, _classnames["default"])({
          'ui-table': true,
          'ui-table__with-border': !noBorder,
          'ui-table--responsive-cards': responsiveCardStyle
        }, className);
      };

      var newChildren;

      if (this.props.onCellClick) {
        newChildren = (0, _filterChildren["default"])(this.props.children, {
          onCellClick: this.onCellClick,
          parent: 'table',
          secondaryDataList: secondaryDataList
        });
      } else {
        newChildren = (0, _filterChildren["default"])(this.props.children, {
          parent: 'table',
          secondaryDataList: secondaryDataList
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: id,
        className: tableClass(),
        style: style
      }, /*#__PURE__*/_react["default"].createElement("table", null, newChildren));
    }
  }]);

  return Table;
}(_react.Component);

Table.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /**
   * Called when a row cell is clicked.  Returns a row number
   *
   */
  onCellClick: _propTypes["default"].func,

  /** Bool to remove the border around the Table */
  noBorder: _propTypes["default"].bool,

  /** Bool to display the table rows as cards on small screens */
  responsiveCardStyle: _propTypes["default"].bool,

  /** Data (in columns) to hide passed from TableRow component */
  secondaryDataList: _propTypes["default"].array,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /**
   * children props for content inside
   * @ignore
   */
  children: _propTypes["default"].node
};
Table.defaultProps = {
  id: '',
  noBorder: false,
  className: '',
  children: [],
  onCellClick: null,
  style: {},
  secondaryDataList: [],
  responsiveCardStyle: false
};
var _default = Table;
exports["default"] = _default;